/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Leveling_Perm_Use_External_Apps_HintInputs */



/**
* | output |
* | --- |
* | "Allows apps that members have added to their account to post messages. When disabled, the messages will be private." |
*
* @param {Leveling_Perm_Use_External_Apps_HintInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const leveling_perm_use_external_apps_hint = /** @type {((inputs?: Leveling_Perm_Use_External_Apps_HintInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Leveling_Perm_Use_External_Apps_HintInputs, { locale?: "en" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ ("Позволяет приложениям, которые участники добавили в свой аккаунт, публиковать сообщения. Если право отключено, такие сообщения будут приватными.")
	return /** @type {LocalizedString} */ ("Allows apps that members have added to their account to post messages. When disabled, the messages will be private.")
});